import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Watch } from 'vue-property-decorator';

@Component
export class TunnelStepMixin extends Vue {
  protected errorMessage: string | null = null;
  protected submitButtonName: string | null = null;

  public async submit() {
    throw new Error('Submit not defined');
  }

  @Watch('submitButtonName')
  @Emit('submit-button-name:updated')
  private watchsSbmitButtonName() {
    return this.submitButtonName;
  }

  @Watch('errorMessage')
  @Emit('error-message:updated')
  private watchErrorMessage() {
    return this.errorMessage;
  }
}
